/* es5-ext/object/is-callable */ function _(require, module, exports) {
    module.exports = function (obj) {
        return typeof obj === "function";
    };
}
